import { createSlice } from "@reduxjs/toolkit";
import {
  countryList,
  countryAreaCode,
  countries,
  stateData
} from "../../constants/countrylist";

const constantsSlice = createSlice({
  name: "constants",
  initialState: {
    formSelectData: {
      countries: countries,
      country: countryList,
      nationalitycountry: countryList,
      birthcountry: countryList,
      citizenshipcountry: countryList,
      citizenshipatbirthcountry: countryList,
      areaCode: countryAreaCode,
      stateData: stateData,
      businesscountryidlist: countryList,
      businesscountry: countryList,
      receivercountry: countryList,
      receivingcountry: countryList,
    },
    transactionTypes: [],
    profileStatus: [],
    systemRoles: []
  },

  reducers: {
    setNewConstants: (state, action) => {
      state.formSelectData = {
        ...state.formSelectData,
        ...action.payload.formSelectData,
      };
    },
    setNewUserConstants: (state, action) => {
      state.newUserConstants = action.payload.newUserConstants;
    },
    setRequiredConstants: (state, action) => {
      console.log(action.payload)
      state.transactionTypes = action.payload.requiredOptions.TransactionTypes;
      state.profileStatus = action.payload.requiredOptions.ProfileStatus;
      state.systemRoles = action.payload.requiredOptions.SystemRoles;
    },
  },
});

export const { setNewConstants, setNewUserConstants, setRequiredConstants } = constantsSlice.actions;

export default constantsSlice.reducer;
